export {VisuallyHidden} from 'react-aria/VisuallyHidden';
export type {VisuallyHiddenAria, VisuallyHiddenProps} from 'react-aria/VisuallyHidden';
